import { useHasJobsAccess } from "domains/hire/hooks/useHasJobsAccess";
import { useFeatureFlag } from "providers/LaunchDarkly";

const useJobsMenuState = () => {
  const hasJobsAccess = useHasJobsAccess();
  const jobsInMainMenu = useFeatureFlag("jobs-in-main-menu");
  return { hasJobsAccess, jobsInMainMenu };
};

/** The Marketplace/Hire switcher goes away once Jobs lives in the main menu. */
export const useShowHireSwitch = () => {
  const { hasJobsAccess, jobsInMainMenu } = useJobsMenuState();
  return hasJobsAccess && !jobsInMainMenu;
};

/** The flip side of the switcher: Jobs gets its own entry in the main menu. */
export const useShowJobsMenuItem = () => {
  const { hasJobsAccess, jobsInMainMenu } = useJobsMenuState();
  return hasJobsAccess && jobsInMainMenu;
};
